export function institutionsForSelectedMenuFoodTypes(
  institutions: IInstitutionData[],
  menuFoodTypeIds: number[]
): IInstitutionData[] {
  if (!menuFoodTypeIds.length) {
    return []
  }

  const typeSet = new Set(menuFoodTypeIds.map(Number))

  const filtered = institutions.filter(institution =>
    institution.menu_institution?.some(menuInstitution => {
      const menuFood = menuInstitution.menu_food
      if (!menuFood?.is_active) {
        return false
      }
      return typeSet.has(Number(menuFood.menu_food_type_id))
    })
  )

  return filtered.sort((a, b) =>
    a.company_social_name.localeCompare(b.company_social_name)
  )
}
